import * as feldm from '~/app/tracking/feld-m-types';
import { CustomerGroupClassification, Incentive } from '~/graphql/__generated__/graphql';

export const mapTrackingIncentives = (incentives: Incentive[]): feldm.ProductDataConfiguredVehicle['incentives'] => {
	// Map the incentive to fit the feldM incentives type

	return incentives.map((incentive) => ({
		id: incentive.id,
		title: incentive.action.title || '',
		value: incentive.price.valueAsText || '',
		targetGroup: getClassificationAsText(incentive.customerGroup.classification),
		discountSelected: incentive.status.selected,
		type: 'dynamic',
		relatedSelection: 'engine',
	}));
};

const getClassificationAsText = (classification: Array<CustomerGroupClassification>) => {
	if (!classification || classification.length < 1) {
		return '';
	}

	let resultText: string = '';
	classification.forEach((entry) => {
		resultText += entry + '|';
	});

	return resultText;
};
